import { PNVendor } from 'apps/orion/src/app/models/supply-visibility.model';
import { Moment } from 'moment';
import { CarriersListService } from '../service/carriers-list.service';
import { CommitsService } from '../service/commits.service';
import { FinancialModuleService } from '../service/financial-module.service';
import { PartNumbersListService } from '../service/partnumbers-list.service';
import { PortfolioService } from '../service/portfolio.service';
import { ShipmentsService } from '../service/shipments.service';
import { SlotsStorageService } from '../service/slots-storage.service';
import { SlotsService } from '../service/slots.service';
import { StocksListService } from '../service/stocks-list.service';
import { SupplyVisibilityService } from '../service/supply-visibility.service';
import { VendorsListService } from '../service/vendors-list.service';
import { DashboardSetting } from './shared-sv.model';

export type Commit = {
  $selected?: boolean;
  actualETADate?: string;
  apsRelevant?: string;
  arrivalDate?: string;
  asn: number;
  batchNo?: string;
  carrier?: string;
  chooseVendor?: string;
  codeDate?: string;
  containerNumber: string;
  countryOfOrigin?: string;
  createDate?: string;
  creator?: string;
  deliveryDate?: string;
  dummyCommit?: DummyCommitDetail;
  dummyCommitHeaderID?: string;
  eddDate?: string;
  editBy?: string;
  etaDate: string;
  etaPortDate?: string;
  etdDate: string;
  expirationDate?: string;
  expressFlag?: string;
  extApproval?: string;
  externalPurchaseOrderLine?: string;
  externalPurchaseOrderNumber?: string;
  forwarder?: string;
  hasDocuments?: boolean;
  hold?: string;
  id?: string;
  inboundDeliveryDate?: string;
  inboundDeliveryNumber?: string;
  index?: number;
  instructionEtaDate?: string;
  invalidEta?: boolean;
  invoiceNumber?: string;
  isModifyByDummy?: boolean;
  isUsedInETA?: boolean;
  lastUpdateDate?: string;
  manufacturer?: string;
  mergedInboundDeliveryNumber?: string;
  mergedQuantity?: number;
  mfgPartner?: string;
  mpn?: string;
  msrRemarks?: string;
  order?: string;
  otmReceiptType?: string;
  otmReceivedDate?: string;
  otmTransactionID?: string;
  parentID?: string;
  parentInboundDeliveryNumber?: string;
  partNumber: string;
  partNumberDescription?: string;
  precedingInboundDeliveryNumber?: string;
  purchaseOrderLine: string;
  purchaseOrderNumber: string;
  purchasingDocumentDate?: string;
  quantity: number;
  reason?: number;
  reasonDetail?: string;
  receiveDate?: string;
  recomitRequestDate: string;
  remainingQuantity?: number;
  remark?: string;
  requestDate?: string;
  requestQuantity?: string;
  responsibility?: string;
  responsibleEmail?: string;
  revision?: string;
  rq?: string;
  rtv?: string;
  sapDeliveryDate?: string;
  scheduleLine?: string;
  scheduleLineDate?: string;
  shipped: boolean;
  shortageComment?: string;
  slotCode?: string;
  slotDate?: string;
  status?: string;
  stockType?: string;
  thirdPartyPaid?: string;
  trackNumber: string;
  transportID?: string;
  triggerDate?: string;
  typeOfTransportation?: string;
  unitWeight: string;
  vendorCode?: string;
  vendorName?: string;
  withMergeModifyQuantity?: boolean;
} & {
  [key: string]: boolean | DummyCommitDetail | null | number | string | undefined;
};

export type SvUrlWithParams = {
  params: Record<string, unknown>;
  url: string;
};

export type DummyCommitHeader = {
  createdBy?: string;
  dateCreated?: string;
  dateModified?: string;
  enumSimulationSet?: number;
  forPrecalculate?: boolean;
  id?: string;
  modifiedBy?: string;
  name: string;
  partNumber: string;
  vendorCode?: string;
};

export type DummyCommitHeaderCls = {
  createdBy?: string;
  dateCreated?: string;
  dateModified?: string;
  details?: unknown[];
  id?: string;
  modifiedBy?: string;
  name: string;
  partNumber: string;
  vendorCode?: string;
};

export type DummyCommitHeadersFilter = {
  partNumber?: string;
  vendorCode?: string;
};

export type DummyCommitDetail = {
  actualETADate?: string;
  apsRelevant?: string;
  arrivalDate?: string;
  asn: number;
  batchNo?: string;
  chooseVendor?: string;
  codeDate?: string;
  containerNumber: string;
  countryOfOrigin?: string;
  creator?: string;
  deliveryDate: string;
  dummyCommitHeaderID: string;
  eddDate?: string;
  etaDate: string;
  etaPortDate?: string;
  etdDate: string;
  expirationDate?: string;
  expressFlag?: string;
  forwarder?: string;
  hasDocuments?: boolean;
  id?: string;
  inboundDeliveryNumber: string;
  invalidEta: boolean;
  invoiceNumber?: string;
  isUsedInETA: boolean;
  manufacturer?: string;
  mfgPartner?: string;
  mpn?: string;
  msrRemarks?: string;
  partNumber: string;
  purchaseOrderLine: string;
  purchaseOrderNumber: string;
  quantity: number;
  reason?: number;
  reasonDetail?: string;
  recomitRequestDate: string;
  remark?: string;
  requestDate?: string;
  scheduleLine?: string;
  scheduleLineDate?: string;
  shipped: boolean;
  shortageComment?: string;
  slotDate?: string;
  status?: string;
  stockType?: string;
  thirdPartyPaid?: string;
  trackNumber: string;
  triggerDate?: string;
  typeOfTransportation?: string;
  unitWeight: string;
  vendorCode: string;
};

export type BasicParameters = {
  $avlLoaded?: boolean;
  $loaded?: boolean;
  [key: string]: boolean | DummyCommitDetail | number | string | undefined | unknown;
  currentPartNumber?: number;
  days?: number;
  fontSize?: number;
  id?: string;
  mmViewID?: string;
  partNumber: string;
  plant: string;
  records?: number;
  variant?: string;
  vendorCode?: string;
  weeks?: number;
  widgetId?: string;
};

export type VendorParametersFilter = {
  partNumbers: string[];
  vendors: string[];
};

export type UserSettingsParameters = {
  key: string; //dashboard name
};

export type PnReviewed = {
  flag?: string;
  partNumber?: string;
  vendorCode?: string;
};

export type PnVendorCode = {
  partNumber?: string;
  plant?: string;
  vendorCode?: string;
};

export type DateRangeParameters = {
  dateFrom?: Date | string;
  dateTo?: Date | string;
};

export class CommitVisualization {
  columnSort!: Array<{ direction: string; field: string }> | null;
  pageSettings!: { pageIndex: number; pageSize: number };
}

export class CommonSvVisualization {
  svSidebarOpened!: boolean;
  svSidebarOpenedSection!: EnumSvSidebarSection;
  svSplitAreaSize!: SvSplitAreaSize;
}

export type SvSplitAreaSize = {
  mainView: number;
  sidebar: number;
};

export enum EnumSvSidebarSection {
  None = -1,
  Notes = 0,
  Comments = 1,
  PNInfo = 2,
  PredefinedComments = 3,
}

export enum EnumSplitEvents {
  End = 0,
  InProgress = 1,
  Start = 2,
}

export type NewCommit = Commit &
  BasicParameters & {
    WithChangePurchaseOrderNumber?: boolean;
    WithPevaConfirm?: boolean;
    withRemerge?: boolean;
  };

export type PurchaseOrders = {
  purchaseOrderItems: purchaseOrderItem[];
  purchaseOrderNumber: string;
};

export type purchaseOrderItem = {
  active: boolean;
  openCommitQuantity: number;
  purchaseOrder_Item: string;
};

export type UserSettings = {
  data: string;
  key: string;
};

export type DefaultDashboardSettings = {
  defaultDashboardId?: { [key: string]: string };
  isLogin?: boolean;
  isPlantChanged?: boolean;
};

export type DialogResult = {
  data?: unknown;
  error?: unknown;
  msg?: string;
  status: boolean;
};

export type DeleteDialogData = {
  callbackData?: unknown;
  confirmationMessage?: string;
  negativeBtnTitle?: string;
  negativeCallbackFunction?: (dialogRef: unknown, args: unknown) => void;
  positiveBtnTitle?: string;
  positiveCallbackFunction?: (dialogRef: unknown, args: unknown) => void;
  title?: string;
};

export type WaterfallDto = {
  ColumnPeriods?: number;
  date?: string;
  partNoVendors?: PnVendorCode[];
  RowPeriods?: number;
};

export class UserSettingsCls {
  data: string = '';
  key: string = '';
}

export type NewUserSetting = UserSettings;

export type CumulativeListDownloadPayload = {
  [key: string]: unknown;
  DummyCommitHeaderID?: null | string;
  fontSize?: number;
  materialManagementViewID?: string;
  MaterialManagementViewID?: string;
  partNoVendors?: Array<{ partNumber: string; vendorCode: string }>;
  PartNumber?: null | string;
  plant?: string;
  Plant?: string;
  records?: number;
  userId?: string;
  variant?: string;
};

export type CumulativeListDownloadResponse = {
  success?: {
    url: string;
  };
};

export type CumulativePayload = {
  DummyCommitHeaderID?: string;
  MaterialManagementViewID?: string;
  partNoVendors?: Array<{ partNumber: string; vendorCode: string }>;
  PartNumber?: string;
  Plant?: string;
  records?: number;
  variant?: string;
} & Record<string, unknown>;

export enum EnumKeyValuePairs {
  All = 0,
  Vendor = 1,
  Formula = 2,
  Buyer = 3,
}

export enum EnumPartNoFilters {
  FixedList = 0,
  Criteria = 1,
}

export enum EnumReviewedStatus {
  AllPNs = 0,
  OnlyReviewedPNs = 1,
  ToBeReviewed = 2,
}

export enum EnumMMViews {
  NO_DATA = 0,
  FOUND = 1,
  NOT_FOUND = 2,
}

export enum EnumControls {
  CheckBox = 0,
  TextBox = 1,
  TextArea = 2,
  NumericBox = 3,
  ComboBox = 4,
}

export enum EnumSaveStates {
  Init = 10,
  InProgress = 20,
  Finished = 30,
}

export enum EnumRequestStatusStatus {
  Error = 'ERROR',
  Notfound = 'NOTFOUND',
  Processing = 'PROCESSING',
  Success = 'SUCCESS',
}

export class KeyValuePair {
  key: number;
  name: string;
  /**
   *
   */
  constructor(key: number, name: string) {
    this.key = key;
    this.name = name;
  }
  public static getPartNoFilterOptions(): KeyValuePair[] {
    const list = [];
    list.push(new KeyValuePair(EnumPartNoFilters.FixedList, 'fixedList'));
    list.push(new KeyValuePair(EnumPartNoFilters.Criteria, 'criteria'));
    return list;
  }
  public static getReviewedStatuses(): KeyValuePair[] {
    const list = [];
    list.push(new KeyValuePair(EnumReviewedStatus.AllPNs, 'allPNs'));
    list.push(new KeyValuePair(EnumReviewedStatus.OnlyReviewedPNs, 'onlyReviewedPNs'));
    list.push(new KeyValuePair(EnumReviewedStatus.ToBeReviewed, 'toBeReviewed'));
    return list;
  }
  public static getOperatorsList(): string[] {
    const list = ['=', '>', '>=', '<', '<='];
    return list;
  }
}

export class KeyTypePair {
  key: number | string;
  type: EnumControls;
  /**
   *
   */
  constructor(key: string, type: EnumControls) {
    this.key = key;
    this.type = type;
  }

  public static getAdditionalFilterList(config: {
    fields: string[];
    mapControls?: boolean;
    widgetType: string;
  }): KeyTypePair[] {
    let data: KeyTypePair[] = [];
    //change condition on other cases
    if (config.widgetType != 'commitList') {
      const list = [];
      if (config.widgetType == 'invoiceList') {
        list.push(new KeyTypePair('VendorCode', EnumControls.TextArea));
        list.push(new KeyTypePair('InvoiceNumber', EnumControls.TextArea));
        list.push(new KeyTypePair('Flags', EnumControls.TextArea));
      } else {
        const isSearchV2 = config.widgetType === 'searchV2';

        if (!isSearchV2) {
          list.push(new KeyTypePair('filterVendorCodes', EnumControls.TextArea));
          list.push(new KeyTypePair('filterBuyers', EnumControls.TextArea));
          list.push(new KeyTypePair('filterContacts', EnumControls.TextArea));
        }
        list.push(new KeyTypePair('filterDeliveryTerms', EnumControls.TextArea));
        list.push(new KeyTypePair('filterTaxCodes', EnumControls.TextArea));
        list.push(new KeyTypePair('filterVirtualVC', EnumControls.CheckBox));
        list.push(new KeyTypePair('filterLeadtimeQuery', EnumControls.NumericBox));
        if (!isSearchV2) {
          list.push(new KeyTypePair('filterMaterialGroups', EnumControls.TextArea));
        }
        list.push(new KeyTypePair('flags', EnumControls.TextArea));
        if (!isSearchV2) {
          list.push(new KeyTypePair('filterExcludeVendorCodes', EnumControls.TextArea));
          list.push(new KeyTypePair('filterExcludeMaterialGroups', EnumControls.TextArea));
        }
        list.push(new KeyTypePair('filterVirtualVCIncludeChild', EnumControls.CheckBox));
      }
      data = list;
    } else if (config.widgetType == 'commitList') {
      const list = [];
      list.push(new KeyTypePair('vendorCode', EnumControls.TextArea));
      list.push(new KeyTypePair('partNumber', EnumControls.TextArea));
      list.push(new KeyTypePair('purchaseOrderNumber', EnumControls.TextArea));
      list.push(new KeyTypePair('purchaseOrderLine', EnumControls.TextArea));
      list.push(new KeyTypePair('inboundDeliveryNumber', EnumControls.TextArea));
      list.push(new KeyTypePair('invoiceNumber', EnumControls.TextArea));
      list.push(new KeyTypePair('trackNumber', EnumControls.TextArea));
      list.push(new KeyTypePair('containerNumber', EnumControls.TextArea));
      list.push(new KeyTypePair('forwarder', EnumControls.ComboBox));
      list.push(new KeyTypePair('remark', EnumControls.TextArea));

      if (config.mapControls) {
        //use mapping if fields come from api and dont have control type
        const mappedList = [];
        for (let i = 0; i < config.fields.length; i++) {
          const index = list.findIndex((e: KeyTypePair): boolean => {
            return e.key.toString().toLowerCase().includes(config.fields[i].toLowerCase());
          });
          if (index != -1) {
            mappedList.push(new KeyTypePair(config.fields[i], list[index].type));
          } else {
            mappedList.push(new KeyTypePair(config.fields[i], EnumControls.TextArea));
          }
        }
        data = mappedList;
      } else {
        //no map
        data = list;
      }
    }

    //IMPLEMENT Other Addition Widgets

    return data;
  }
}

export type CommitsFilterDTO = {
  dateFrom?: Date;
  dateTo?: Date;
  inboundDeliveryNumbers?: string[];
  invoiceNumbers?: string[];
  partNumbers?: string[];
  purchaseOrderLines?: string[];
  purchaseOrderNumbers?: string[];
  status?: string;
  trackNumbers?: string[];
  vendorCodes?: string[];
};

export type CommitsFilterStrDtDTO = {
  buyers?: string[];
  contacts?: string[];
  ContainerNumber?: string[];
  dateFrom?: string;
  dateTo?: string;
  Forwarder?: string[];
  inboundDeliveryNumbers?: string[];
  invoiceNumbers?: string[];
  partNumbers?: string[];
  plannedOrderStatus?: string[];
  purchaseOrderLines?: string[];
  purchaseOrderNumbers?: string[];
  Remark?: string[];
  RequestNumbers?: string[];
  status?: string[];
  trackNumbers?: string[];
  vendorCodes?: string[];
};

export type CommitsFilterDownloadDTO = CommitsFilterStrDtDTO & {
  commitIDs?: string[];
  dateFrom?: string;
  dateTo?: string;
  Fields?: string[];
  sorts?: unknown;
  type?: string;
} & {
  [K in DynamicDateKey]?: string;
};

type DateSuffix = 'From' | 'To';

export type DynamicDateKey = `${string}${DateSuffix}`;

export type CommitsFilterDto = {
  buyers?: string;
  CheckLargeData?: boolean;
  commitIDs?: string;
  contacts?: string;
  ContainerNumber?: string;
  creators?: string;
  dateFrom?: string;
  dateTo?: string;
  dateType?: string;
  Forwarder?: string[];
  inboundDeliveryNumbers?: string;
  includeParentIDs?: string[];
  invoiceNumbers?: string;
  partNumbers?: string;
  plannedOrderStatus?: string;
  purchaseOrderLines?: string;
  purchaseOrderNumbers?: string;
  Remark?: string;
  requestNumbers?: string;
  rqs?: string;
  sorts?: unknown;
  status?: string[];
  trackNumbers?: string;
  vendorCodes?: string[];
} & {
  [K in DynamicDateKey]?: string;
};

export type CommitsFilterUIModel = {
  buyers?: string[];
  CheckLargeData?: boolean;
  commitIDs?: string[];
  contacts?: string[];
  ContainerNumber?: string[];
  creators?: string[];
  dateFrom?: string;
  dateTo?: string;
  dateType?: string;
  Forwarder?: string[];
  inboundDeliveryNumbers?: string[];
  includeParentIDs?: string[];
  invoiceNumbers?: string[];
  partNumbers?: string[];
  plannedOrderStatus?: string[];
  purchaseOrderLines?: string[];
  purchaseOrderNumbers?: string[];
  Remark?: string[];
  requestNumbers?: string[];
  rqs?: string[];
  sorts?: unknown;
  status?: string[];
  trackNumbers?: string[];
  vendorCodes?: string[];
} & {
  [K in DynamicDateKey]?: string;
};

export type BatchEditCommits = {
  fields: Array<{ key: string; value: boolean | Date | Moment | null | number | string }>;
  inboundDeliveryNumbers: string[];
};

export type SecurityLevelData = {
  id: number;
  label: string;
};

export type notificationSignalRDto = {
  DateCreated?: string;
  Id: string;
  IsRead?: string;
  Message?: string;
  Title?: string;
  UserId?: string;
};

export type PageHeaderAction = {
  actionData: boolean | DashboardSetting | null;
  actionType: EnumPageHeaderAction;
};

export enum EnumPageHeaderAction {
  DashboardAdd = 0,
  DashboardEdit = 1,
  DashboardCopy = 2,
  DashboardDelete = 3,
  DashboardLock = 4,
  //Add Other Events
  DashboardImport = 5,
  DashboardLoading = 10,
}

export enum EnumCommitFieldStructure {
  CommitTable = 0,
  CommitForm = 1,
  BulkEditForm = 2,
  SplitForm = 3,
  HistoryTable = 4,
  DocumentTable = 5,
  DocumentCreateForm = 6,
  DocumentEditForm = 7,
  ChartSettingsTable = 8,
  ChartSettingsCreateForm = 9,
  ChartSettingsEditForm = 10,
  CommitHistoryTable = 11,
  TemplateFilterTable = 12,
  TemplateFilterCreateForm = 13,
  TemplateFilterEditForm = 14,
}

export class FieldVisibilitySetting {
  field = '';
  visible = false;
  index?: number;
}

export type ManufacturerDetailsDto = {
  cpnStatusCode: string;
  mfgName: string;
  mfgpn: string;
  partNumber: string;
  primaryKey?: number;
  productRevision: string;
  vendorCode: string;
};

export type BuyersInfo = {
  active: boolean;
  additionalInfos?: unknown[];
  addresses?: unknown[];
  contactType?: string;
  email?: string;
  firstName?: string;
  id?: null | string;
  identityKey?: null | string;
  lastName?: string;
  partNumber?: string;
  phone?: string;
  validFrom?: Date;
  validTo?: Date;
  vendorCode?: string;
};

export type ApiResponse<T> = {
  error?: unknown;
  msg?: string;
  result: T;
  status: boolean;
};

export type FormKeys = {
  [key: string]: unknown;
};

export type DashboardPanelModel = {
  [key: string]: unknown;
};

// MaterialManagementViews, ForecastDetail, ForecastWeekRange, ForecastVirtualVc should be imported from their respective models

export class LinkEventsDialogComponent {}

export type FilterParams = {
  buyers: null | string[];
  contacts: null | string[];
  customQuery: null | string;
  filterDeliveryTerms: null | string[];
  filterExcludeMaterialGroups: null | string[];
  filterExcludeVendorCodes: null | string[];
  filterLeadtimeQuery: null | string;
  filterSearch: null | string;
  filterTaxCodes: null | string[];
  filterVariant: null | string;
  filterVirtualVC: boolean | null;
  filterVirtualVCIncludeChild: boolean | null;
  flags?: null | string[];
  formula: null | string;
  fulltextSearch?: boolean;
  loadVendorName?: boolean;
  materialGroups?: null | string[];
  partNumbers: null | PNVendor[];
  sorting: null | string;
  vendors: null | string[];
} & {
  [key: string]: unknown;
};

export type PnVcFlags = {
  createdBy?: string;
  dateCreated?: string;
  dateModified?: string;
  flags?: string[];
  id?: string;
  key?: string;
  modifiedBy?: string;
  partNumber?: string;
  vendorCode?: string;
};

export type ForecastDate = {
  createdBy: string;
  date: string;
  dateCreated: string;
  dateModified: string;
  flags: string[];
  id: string;
  modifiedBy: string;
};

export type ValidCombination = {
  isValidCombination?: boolean;
  isValidQuota?: boolean;
};

export type ModuleService =
  | CarriersListService
  | CommitsService
  | FinancialModuleService
  | PartNumbersListService
  | PortfolioService
  | ShipmentsService
  | SlotsService
  | SlotsStorageService
  | StocksListService
  | SupplyVisibilityService
  | VendorsListService;

export type ModuleServiceMap = {
  [key: string]: ModuleService;
};

export type StaticValues = {
  calculation?: string;
  calculationrule?: string;
  calculationvalue?: string;
  label?: string;
  value?: number | string;
};
